import api from './api'

export default function homeEmergency (id) {

	const myapp = new Vue({
		delimiters: ['${', '}'],
		el: '#v-home-emergency',
		data () {
			return {
				loading: false,
				items: null
			}
		},
		computed: {
			hasItem () {
				return !this.loading && this.items && this.items.length
			}
		},
		methods: {
			load () {
				this.loading = true
				this.items = null
				const params = {
					parent: id,
					limit: 3,
					tag: '重要なお知らせ'
				}
				return api.pages(params).then(res => {
					this.items = res.data
					this.loading = false
				})
			}
		},
		created () {
			this.load()
		}
	})

}